import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Skeletons } from 'ui/components/skeleton';
import _ from 'underscore';

import { Invoice } from 'services/action';

import { FormPayment, FormAdditional } from '../form';

const initialState = {
  privilege: null,
  showDelete: false,
  showPayment: false,
  showAdditional: false,
};

export const Action = ({ data, onSubmit, isLoading,  }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ privilege, showDelete, showPayment, showAdditional }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showPayment: false, showAdditional: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Invoice.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/invoice');
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.invoice',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };


  const StandardAction = () => {
    return privilege?.action === 'manage' || !Session?.privileges ? (
      <>
        {data?.document_status === 'new' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
            >
              <Link
                to={`/invoice/update/${data?.id}`}
                className={cn('btn btn-primary px-2')}
              >
                <Fi.FiEdit size="17" />
              </Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
            >
              <button
                className={cn('btn btn-danger px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showDelete: true }))
                }
              >
                <Fi.FiTrash2 size="17" />
              </button>
            </OverlayTrigger>
          </>
        )}

        {data?.document_status !== 'paid' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Buat Pembayaran</Tooltip>}
            >
              <button
                className={cn('btn btn-secondary px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showPayment: true }))
                }
              >
                <Fi.FiCreditCard size="17" />
              </button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Tambahan Harga</Tooltip>}
            >
              <button
                className={cn('btn btn-secondary px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showAdditional: true }))
                }
              >
                <Fi.FiPlus size="17" />
              </button>
            </OverlayTrigger>
          </>
        )}
      </>
    ) : null;
  };

  return (
    <div className="d-flex align-items-center gap-1 px-md-3 px-2  px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Print Invoice</Tooltip>}
          >
            <Link
              to={`/print/invoice/${data?.id}`}
              className="btn btn-secondary px-2"
              target="_blank"
            >
              <Fi.FiPrinter size="17" />
            </Link>
          </OverlayTrigger>
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPayment}
        onHide={() =>
          setState((prevState) => ({ ...prevState, showPayment: false }))
        }
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Pembayaran</Modal.Title>
        </Modal.Header>
        <FormPayment
          data={data}
          onClose={() => {
            onSubmit();
            $handleClose();
          }}
        />
      </Modal>

      <Modal
        show={showAdditional}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Biaya Tambahan</Modal.Title>
        </Modal.Header>
        <FormAdditional
          data={data}
          onClose={() => {
            onSubmit();
            $handleClose();
          }}
        />
      </Modal>
    </div>
  );
};
